export interface SearchOrderBy {
    value: any;
    label: string;
}

export class SearchOrderByHelper {

    static create(): SearchOrderBy {
        return {
            value: '',
            label: ''
        };
    }

    static transformFromApi(apiData: Object): SearchOrderBy {
        const searchFeature = SearchOrderByHelper.create();
        searchFeature.value = apiData['POSICION'];
        searchFeature.label = apiData['TEXTO'];
        return searchFeature;
    }
}